<template>
  <ts-loading-banner :loading="waiting">
    <div class="tw-space-y-4">
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{ $t("levelSkill.skillEn") }}</label>
          <a-select
            class="tw-w-full"
            v-model.number="model.skill_profile_id"
            :class="{ 'is-invalid': errors.has('skill_profile_id') }"
            @change="onSkillChange"
          >
            <a-select-option
              v-for="(skill, index) in skills"
              :key="index"
              :value="skill.skill_profile_id"
            >
              {{ skill.skill_name_en }}
              <span
                v-if="skill.is_accessor"
                class="badge bg-primary mr-2 tw-capitalize"
              >
                Accessor</span
              >
            </a-select-option>
          </a-select>
          <div class="invalid-feedback" v-if="errors.has('skill_profile_id')">
            {{ errors.first("skill_profile_id") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{ $t("levelSkill.skillLevelOrder") }}</label>
          <input
            v-model.number="model.skill_level_order"
            type="number"
            class="form-control"
            :class="{ 'is-invalid': errors.has('skill_level_order') }"
            :placeholder="$t('levelSkill.skillLevelOrder')"
          />
          <div class="invalid-feedback" v-if="errors.has('skill_level_order')">
            {{ errors.first("skill_level_order") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{ $t("levelSkill.levelSkillName") }}</label>
          <input
            readonly
            v-model="model.level_skill_name"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('level_skill_name') }"
            :placeholder="$t('levelSkill.levelSkillName')"
          />
          <div class="invalid-feedback" v-if="errors.has('level_skill_name')">
            {{ errors.first("level_skill_name") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 tw-space-y-1">
          <label>{{ $t("levelSkill.qualificationTemplate") }}</label>
          <div
            class="
              tw-border
              tw-h-72
              tw-w-full
              tw-rounded-lg
              tw-p-1
              tw-bg-white
              tw-overflow-hidden
              tw-relative
            "
          >
            <img
              class="tw-w-full tw-h-full"
              v-lazy="{
                src: file1,
                loading: require('@/assets/Rolling-1s-200px.svg'),
                preLoad: 1.3,
                attempt: 1,
              }"
            />
          </div>
        </div>
        <div class="col-6 tw-space-y-1">
          <label>{{ $t("levelSkill.competencyTemplate") }}</label>
          <div
            class="
              tw-border
              tw-h-72
              tw-w-full
              tw-rounded-lg
              tw-p-1
              tw-bg-white
              tw-overflow-hidden
              tw-relative
            "
          >
            <img
              v-if="objectContain"
              class="tw-w-full tw-h-full tw-object-contain"
              v-lazy="{
                src: file2,
                loading: require('@/assets/Rolling-1s-200px.svg'),
                preLoad: 1.3,
                attempt: 1,
              }"
            />
            <img v-else :src="file2" alt="" class="tw-w-full tw-h-full" />
          </div>
        </div>
      </div>
      <div class="row tw-mt-2">
        <div class="col-md-12 tw-flex tw-justify-end tw-space-x-3">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t("cancel") }}
          </ts-button>
          <ts-button
            v-if="!isUpdate"
            color="primary"
            outline
            :waiting="waiting_new"
            :disabled="waiting_new || waiting"
            @click.prevent="onSaveAddNew"
          >
            {{ $t("saveAddNew") }}</ts-button
          >
          <ts-button v-if="!isUpdate" color="primary" @click.prevent="onSave">{{
            $t("save")
          }}</ts-button>
          <ts-button
            v-if="isUpdate"
            color="primary"
            @click.prevent="onUpdate"
            >{{ $t("update") }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { debounce, isEmpty } from "lodash";
import { Errors } from "form-backend-validation";
import { mapActions, mapState } from "vuex";
export default {
  name: "levelSkillForm",
  data() {
    return {
      objectContain: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      showBrowseFileBotton: false,
      file1: require("../../../assets/default-image.jpg"),
      file2: require("../../../assets/default-image.jpg"),
      skills: [],
      model: {
        skill_profile_id: null,
        level_skill_name: null,
        skill_level_order: null,
        certification_template: null,
        competency_template: null,
      },
    };
  },
  computed: {
    ...mapState("academic/levelSkill", ["edit_data", "formViewDatas"]),
    isUpdate() {
      return !isEmpty(this.edit_data);
    },
  },
  async created() {
    await this.fetchFormViewModel();
    this.setEditData();
  },
  methods: {
    ...mapActions("academic/levelSkill", ["getFormViewData"]),
    fetchFormViewModel() {
      this.waiting = true;
      this.$store
        .dispatch("academic/levelSkill/getFormViewData")
        .then((response) => {
          this.skills = response.data.skills;
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    onSkillChange() {
      if (this.model.skill_level_order && this.model.skill_profile_id) {
        let skillProfile = this.skills.find(
          (e) => e.skill_profile_id == this.model.skill_profile_id
        );

        this.model.level_skill_name =
          skillProfile.prefix_code + this.model.skill_level_order;

        this.file2 = require("../../../../../../public/assets/templates/competency-parts.jpg");
        this.objectContain = true;

        if (skillProfile.is_accessor) {
          this.file1 = require("../../../../../../public/assets/templates/methodology-certificate.jpg");
        } else if (!skillProfile.is_accessor) {
          switch (this.model.skill_level_order) {
            case 1:
              this.file1 = require("../../../../../../public/assets/templates/national-qualification-level-1.jpg");
              break;
            case 2:
              this.file1 = require("../../../../../../public/assets/templates/national-qualification-level-2.jpg");
              break;
            case 3:
              this.file1 = require("../../../../../../public/assets/templates/national-qualification-level-3.jpg");
              break;
            case 4:
              this.file1 = require("../../../../../../public/assets/templates/national-qualification-level-4.jpg");
              break;
            case 5:
              this.file1 = require("../../../../../../public/assets/templates/national-qualification-level-5.jpg");
              break;
            default:
              this.file1 = require("../../../assets/default-image.jpg");
              this.file2 = require("../../../assets/default-image.jpg");
              this.objectContain = false;
              break;
          }
        }
      } else {
        this.file1 = require("../../../assets/default-image.jpg");
        this.file2 = require("../../../assets/default-image.jpg");
        this.objectContain = false;
      }
    },
    async onSave() {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch("academic/levelSkill/store", Object.assign({}, this.model))
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.$emit("fetchData");
          this.$emit("cancel");
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onSaveAddNew() {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch("academic/levelSkill/store", Object.assign({}, this.model))
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.clearEdit();
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onUpdate() {
      this.waiting = true;
      this.$store
        .dispatch("academic/levelSkill/update", {
          id: this.model.level_skill_id,
          data: this.model,
        })
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.$emit("fetchData");
          this.$emit("cancel");
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.level_skill_id = this.edit_data.level_skill_id;
        this.model.skill_profile_id = this.edit_data.skill_profile_id;
        this.model.level_skill_name = this.edit_data.level_skill_name;
        this.model.skill_level_order = this.edit_data.skill_level_order;
        this.model.certification_template =
          this.edit_data.certification_template;
        if (this.model.certification_template) {
          this.file1 = this.model.certification_template;
        }
        this.model.competency_template = this.edit_data.competency_template;
        if (this.model.competency_template) {
          this.file2 = this.model.competency_template;
        }
      }
    },
    clearEdit() {
      this.model.skill_profile_id = null;
      this.model.level_skill_name = null;
      this.model.skill_level_order = null;
      this.model.certification_template = null;
      this.model.competency_template = null;
    },
  },
  watch: {
    "model.skill_level_order": debounce(async function () {
      await this.onSkillChange();
    }, 500),
  },
};
</script>

<style lang="scss" scoped>
</style>